<div class="container-fluid  pt-4 pb-4 mb-1 d-flex flex-column">
  <div class="row">
    <div class="col-md-12 order-md-2">
      <h6 class="text-muted text-normal text-uppercase">DASHBOARD</h6>
      <hr class="margin-bottom-1x">
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <div class="product-card">
            <div class="product-card-thumb"> <span class="product-badge text-danger">Pooja</span><a class="product-card-link"
              [routerLink]="bookingRoute"></a><img src="assets/img/dashboard/pooja.png" style="width:50%; height:75%" alt="Product">
              <div class="product-card-buttons">
                <button class="btn btn-white btn-sm btn-wishlist" data-bs-toggle="tooltip" title="Wishlist"><i class="material-icons favorite_border"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="product-card">
            <div class="product-card-thumb"> <span class="product-badge text-danger">Expense</span><a class="product-card-link"
              routerLink="/app/stoda/create-bill"></a><img src="assets/img/dashboard/shopping-cart.png" style="width:50%; height:75%" alt="Product">
              <div class="product-card-buttons">
                <button class="btn btn-white btn-sm btn-wishlist" data-bs-toggle="tooltip" title="Wishlist"><i class="material-icons favorite_border"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="product-card">
            <div class="product-card-thumb"> <span class="product-badge text-danger">Auditorium</span><a class="product-card-link"
              routerLink="/app/auditorium"></a><img src="assets/img/dashboard/hall.png" style="width:50%; height:75%" alt="Product">
              <div class="product-card-buttons">
                <button class="btn btn-white btn-sm btn-wishlist" data-bs-toggle="tooltip" title="Wishlist"><i class="material-icons favorite_border"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="product-card">
            <div class="product-card-thumb"> <span class="product-badge text-danger">Membership</span><a class="product-card-link"
              routerLink="/app/membership/membership-booking"></a><img src="assets/img/dashboard/id-card.png" style="width:50%; height:75%" alt="Product">
              <div class="product-card-buttons">
                <button class="btn btn-white btn-sm btn-wishlist" data-bs-toggle="tooltip" title="Wishlist"><i class="material-icons favorite_border"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
     <br><br><br><br>
      <div class="row">
        <div class="col-md-3 col-sm-6">
          <div class="product-card">
            <div class="product-card-thumb"> <span class="product-badge text-danger">Salary</span><a class="product-card-link"
              routerLink="/app/salary/salary"></a><img src="assets/img/dashboard/newspaper.png" style="width:50%; height:75%" alt="Product">
              <div class="product-card-buttons">
                <button class="btn btn-white btn-sm btn-wishlist" data-bs-toggle="tooltip" title="Wishlist"><i class="material-icons favorite_border"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="product-card">
            <div class="product-card-thumb"> <span class="product-badge text-danger">Report</span><a class="product-card-link"
              routerLink="/app/reports/pooja/collection"></a><img src="assets/img/dashboard/analytics.png" style="width:50%; height:75%" alt="Product">
              <div class="product-card-buttons">
                <button class="btn btn-white btn-sm btn-wishlist" data-bs-toggle="tooltip" title="Wishlist"><i class="material-icons favorite_border"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="product-card">
            <div class="product-card-thumb"> <span class="product-badge text-danger">Payable</span><a class="product-card-link"
              routerLink="/app/reports/payable"></a><img src="assets/img/dashboard/credit-card.png" style="width:50%; height:75%" alt="Product">
              <div class="product-card-buttons">
                <button class="btn btn-white btn-sm btn-wishlist" data-bs-toggle="tooltip" title="Wishlist"><i class="material-icons favorite_border"></i></button>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-3 col-sm-6">
          <div class="product-card">
            <div class="product-card-thumb"> <span class="product-badge text-danger">Receivable</span><a class="product-card-link"
              routerLink="/app/reports/receivable"></a><img src="assets/img/dashboard/discount.png" style="width:50%; height:75%" alt="Product">
              <div class="product-card-buttons">
                <button class="btn btn-white btn-sm btn-wishlist" data-bs-toggle="tooltip" title="Wishlist"><i class="material-icons favorite_border"></i></button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>